module.exports = __webpack_public_path__ + "img/Shape-1.f0fb2612.svg";